import { render, staticRenderFns } from "./Conections.vue?vue&type=template&id=60074e76"
import script from "./Conections.vue?vue&type=script&lang=js"
export * from "./Conections.vue?vue&type=script&lang=js"
import style0 from "./Conections.vue?vue&type=style&index=0&id=60074e76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports